import { useState, useCallback } from 'react';
// import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _remove from 'lodash/remove';
import _keys from 'lodash/keys';
import _forEach from 'lodash/forEach';
import _isArray from 'lodash/isArray';
import _isNil from 'lodash/isNil';
import _trim from 'lodash/trim';

const useRequiredFields = () => {
    const [invalidRequiredFields, setInvalidRequiredFields] = useState();

    const clearInvalidRequiredField = useCallback(
        name => {
            // clear error highlight
            if (invalidRequiredFields) {
                const newInvalidRequiredFields = [...invalidRequiredFields];
                _remove(newInvalidRequiredFields, o => o === name);
                setInvalidRequiredFields(newInvalidRequiredFields);
            }
        },
        [invalidRequiredFields],
    );

    const getFieldError = useCallback(
        name => {
            return _includes(invalidRequiredFields, name);
        },
        [invalidRequiredFields],
    );

    const validateRequiredFields = useCallback(requiredFields => {
        const fieldNames = _keys(requiredFields);
        // let isRequiredFieldsFilled = true;
        const errorFields = [];
        _forEach(fieldNames, fieldName => {
            const field = requiredFields[fieldName];
            if (_isNil(field) || _trim(field) === '' || (_isArray(field) && field.length === 0)) {
                errorFields.push(fieldName);
            }
        });
        setInvalidRequiredFields(errorFields);

        return errorFields.length === 0;
    }, []);

    return {
        invalidRequiredFields,
        setInvalidRequiredFields,
        getFieldError,
        clearInvalidRequiredField,
        validateRequiredFields,
    };
};

export default useRequiredFields;
